// Must stay the first import: modules evaluated before it fail unreported.
import './bugfender-boot'

import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'

import { environment } from '@env'

import { crashReporter } from '@utils/crash-reporter'
import { startApp } from '@utils/start-app'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

if (environment.production) {
	enableProdMode()
}

startApp(() => bootstrapApplication(AppComponent, appConfig), crashReporter)
